import { render, staticRenderFns } from "./CablePricesEdit.vue?vue&type=template&id=6f2cf280&scoped=true"
import script from "./CablePricesEdit.vue?vue&type=script&lang=js"
export * from "./CablePricesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2cf280",
  null
  
)

export default component.exports